import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { TermService } from 'app/services';

import { SingleTermPage } from 'app/pages/single-term/single-term.page';

import { Term } from 'app/interfaces/api/types';

import { DomHelper } from 'app/classes/dom-helper/dom-helper';

@Component({
  selector: 'app-glossary',
  templateUrl: './glossary.page.html',
  styleUrls: ['./glossary.page.scss'],
})

export class GlossaryPage implements OnInit {
  @ViewChild('content', { read: ElementRef, static: false })
  private content: ElementRef;

  public terms: Term[] = [];
  public initials: string[] = [];
  public searchQuery: string = '';
  public didLoad: boolean = false

  constructor(
    private readonly termService: TermService,
    private readonly modalCtrl: ModalController
  ) { }

  ngOnInit(): void { }

  ionViewWillEnter(): void {
    this.reset();
  }

  async ionViewDidEnter(): Promise<void> {
    this.terms = await this.termService.getAll();

    const initials: string[] = this.terms.map(({ name }) => name[0].toUpperCase());

    this.initials = Array.from(new Set(initials)).sort();

    DomHelper.whenReady(this.content.nativeElement).then(() => this.didLoad = true);
  }

  public getFilteredInitials(): string[] {
    const initials: string[] = this.getFilteredTerms()
      .map((t: Term) => t.name[0].toUpperCase());

    return this.initials
      .filter((initial: string) => initials.includes(initial));
  }

  public getFilteredTerms(): Term[] {
    return this.terms
      .filter((t: Term) => t.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
  }

  public getTermsByInitial(initial: string): Term[] {
    return this.getFilteredTerms()
      .filter((t: Term) => t.name[0].toUpperCase() === initial);
  }

  public termClicked(term: Term) {
    this.modalCtrl.create({
      component: SingleTermPage,
      componentProps: {
        term: term
      }
    }).then((modal) => {
      modal.present();
    });
  }

  private reset(): void {
    this.didLoad = false;
    this.terms = [];
    this.initials = [];
    this.searchQuery = '';
  }
}
